export const API_PATHS = {
  USER_DEVICES: '/api/v1/devices',
} as const;

export type ApiPathKey = keyof typeof API_PATHS;
